import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import { apiFetchDailyRouteLeadingCountUseEdiAPI, apiFetchDailyRouteLeadingCountUseMaxAPI } from '../../api/DailyRouteLeadingCountUseEdiOrUseMaxAPI';
import { USE_EDI_REQUEST, USE_MAX_REQUEST } from '../actions/types/DailyRouteLeadingCountUseEdiOrUseMaxActionsTypes';
import {
  postDailyRouteLeadingCountUseEdiSuccessActionCreator,
  postDailyRouteLeadingCountUseEdiFailureActionCreator,
  postDailyRouteLeadingCountUseMaxSuccessActionCreator,
  postDailyRouteLeadingCountUseMaxFailureActionCreator,
} from '../actions/DailyRouteLeadingCountUseEdiOrUseMaxActions';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';

function* doDailyRouteLeadingCountUseEdiWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchDailyRouteLeadingCountUseEdiAPI, action.payload);
    yield put(postDailyRouteLeadingCountUseEdiSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.daily-route-leading.use.edi.success'),
    }));
  } catch (error) {
    yield put(postDailyRouteLeadingCountUseEdiFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.daily-route-leading.use.edi.failure'),
    }));
  }
}

function* doDailyRouteLeadingCountUseMaxWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchDailyRouteLeadingCountUseMaxAPI, action.payload);
    yield put(postDailyRouteLeadingCountUseMaxSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.daily-route-leading.use.max.success'),
    }));
  } catch (error) {
    yield put(postDailyRouteLeadingCountUseMaxFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'notification.daily-route-leading.use.max.failure'),
    }));
  }
}

function* doDailyRouteLeadingCountUseEdiOrMaxWatcher() {
  yield takeLatest(USE_EDI_REQUEST, doDailyRouteLeadingCountUseEdiWorker);
  yield takeLatest(USE_MAX_REQUEST, doDailyRouteLeadingCountUseMaxWorker);
}

export default doDailyRouteLeadingCountUseEdiOrMaxWatcher;
export {
  doDailyRouteLeadingCountUseMaxWorker,
  doDailyRouteLeadingCountUseEdiWorker,
};
